import { classNames } from "../App";

export default function HRDashboardDayofWeek({ days, onDaySelect, selectedDay }) {
    return (
        <div className="grid grid-cols-4 sm:grid-cols-7 gap-2 mb-4">
            {days.map((day) => (
                <button onClick={() => onDaySelect(day.index)} key={day.index} className={classNames(
                    "btn w-full",
                    day.disabled && "btn-disabled",
                    !day.disabled && day.index != selectedDay && "text-black bg-white outline-primary border-primary hover:bg-primary-dark",
                    !day.disabled && day.index == selectedDay && "text-white bg-primary hover:bg-primary cursor-default"
                )}>{day.name}</button>
            ))}
        </div>
    )
}